import { Messages } from "@crispico/foundation-gwt-js";
//@ts-ignore
import foundationMessages from "./messages-foundation.tsv";
//@ts-ignore
import appMessages from "messages/messages.tsv";

const messages = Messages.getInstance();
messages.parseTsvContent(foundationMessages, false);
messages.parseTsvContent(appMessages, false);